import { render, staticRenderFns } from "./OrderNowInfiniteScroll.vue?vue&type=template&id=7b7dfe8c&scoped=true&"
import script from "./OrderNowInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./OrderNowInfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./OrderNowInfiniteScroll.vue?vue&type=style&index=0&id=7b7dfe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7dfe8c",
  null
  
)

export default component.exports